import { render, staticRenderFns } from "./explain-optimize-menu.component.vue?vue&type=template&id=06515e44&scoped=true"
import script from "./explain-optimize-menu.component.vue?vue&type=script&lang=ts"
export * from "./explain-optimize-menu.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-optimize-menu.component.vue?vue&type=style&index=0&id=06515e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06515e44",
  null
  
)

export default component.exports